import { FC, useMemo } from 'react';
import { useGridDataFromServer } from '@chargeafter/providers';
import { Box, styled } from '@mui/material';
import { useGetColumns } from '../services/tableManager';
import { useGetStoreId } from '../services/storeManager';
import { ColumnMeta, DataGrid } from '@chargeafter/data-grid';

import { NoData } from '../components/NoData';
import StatusChip from '../components/StatusChip';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 3, 0, 3),
  height: 'calc(100vh - 20px - 64px - 48px - 48px)',
}));

const TransactionsTab: FC = () => {
  const storeId = useGetStoreId();
  const { columns, loadServerRows } = useGridDataFromServer({
    collection: 'consumersCharges',
    getColumns: useGetColumns,
    customQueryInput: {
      storeId,
    },
  });

  const newColumns: ColumnMeta[] = useMemo(() => {
    return columns.map((col: ColumnMeta) => {
      const newColumn = { ...col };
      newColumn.minWidth = 100;
      if (col.field === 'status') {
        newColumn.minWidth = 160;
        newColumn.renderCell = (params: GridRenderCellParams) => {
          const { value } = params;
          return <StatusChip status={value} />;
        };
      } else if (col.field === 'amount') {
        newColumn.headerAlign = 'left';
        newColumn.align = 'left';
      }
      return newColumn;
    });
  }, [columns]);

  return (
    <Container>
      <DataGrid
        gridPreLoader={false}
        noDataComponent={<NoData type="transaction" />}
        shouldPaginate
        columns={newColumns}
        loadServerRows={loadServerRows}
        toolbar={null}
      />
    </Container>
  );
};

export default TransactionsTab;
